import { FC, PropsWithChildren } from 'react'

const EmptyLayout: FC<PropsWithChildren> = ({ children }) => <>{children}</>

export default EmptyLayout
